import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from './App'
import { AuthProvider, useAuth } from './auth'
import { I18nProvider, useLanguageHints } from './i18n'
import { PlatformProvider, usePlatform, usePlatformReady } from './platform'
import './styles.css'

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing from index.html')

/** Reports the tenant's language: the default for a visitor who has not chosen. */
function PlatformLanguage() {
  const platform = usePlatform()
  const ready = usePlatformReady()
  useLanguageHints({ platform: ready ? platform.locale : null })
  return null
}

/** Reports the signed-in learner's saved language, which outranks the tenant's. */
function AccountLanguage() {
  const { user } = useAuth()
  useLanguageHints({ account: user?.locale ?? null, signedIn: user !== null })
  return null
}

createRoot(root).render(
  <StrictMode>
    <I18nProvider>
      <PlatformProvider>
        <PlatformLanguage />
        <AuthProvider>
          <AccountLanguage />
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </PlatformProvider>
    </I18nProvider>
  </StrictMode>,
)
